let fullscreenAppListener = null;

export default {
  state: {
    isAppFullscreen: false,
  },
  mutations: {
    SET_FULLSCREEN_STATE(state, value) {
      state.isAppFullscreen = value;
    },
  },
  actions: {
    SET_APP_FULLSCREEN({ commit }, value) {
      if (value) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },

    INIT_FULLSCREEN_LISTENER({ commit }) {
      if (fullscreenAppListener) return;

      fullscreenAppListener = () => {
        const isFullscreen = Boolean(
          document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement
        );
        commit('SET_FULLSCREEN_STATE', isFullscreen);
      };

      document.addEventListener('fullscreenchange', fullscreenAppListener);
      document.addEventListener(
        'webkitfullscreenchange',
        fullscreenAppListener
      );
      document.addEventListener('mozfullscreenchange', fullscreenAppListener);
      document.addEventListener('MSFullscreenChange', fullscreenAppListener);
    },

    REMOVE_FULLSCREEN_LISTENER() {
      if (!fullscreenAppListener) return;

      document.removeEventListener('fullscreenchange', fullscreenAppListener);
      document.removeEventListener(
        'webkitfullscreenchange',
        fullscreenAppListener
      );
      document.removeEventListener(
        'mozfullscreenchange',
        fullscreenAppListener
      );
      document.removeEventListener('MSFullscreenChange', fullscreenAppListener);

      fullscreenAppListener = null;
    },
  },

  getters: {
    isAppFullscreen: (state) => state.isAppFullscreen,
  },
};
